import { use as i18nextUse } from "i18next";
import { initReactI18next } from "react-i18next";

import checkoutCZ from "./cz/checkout.json";
import checkoutSK from "./sk/checkout.json";

import basketCZ from "./cz/basket.json";
import basketSK from "./sk/basket.json";

import headerCZ from "./cz/header.json";
import headerSK from "./sk/header.json";

import generalCZ from "./cz/general.json";
import generalSK from "./sk/general.json";

import detailCZ from "./cz/detail.json";
import detailSK from "./sk/detail.json";

export const defaultNS = "general";

export const resources = {
    cz: {
        basket: basketCZ,
        checkout: checkoutCZ,
        header: headerCZ,
        general: generalCZ,
        detail: detailCZ,
    },
    sk: {
        basket: basketSK,
        checkout: checkoutSK,
        header: headerSK,
        general: generalSK,
        detail: detailSK,
    },
} as const;

void i18nextUse(initReactI18next)
    .init({
        resources,
        defaultNS,
        ns: ["general", "header", "basket", "checkout", "detail"],
        fallbackLng: "cz",
        debug: false,
        interpolation: {
            escapeValue: false,
        },
        returnNull: false,
    });

export { default } from "i18next";
